import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerComponent } from "ngx-spinner";
import { TranslatePipe } from "@shared/pipes/auto-translate.pipe";
import { LanguagePreferenceService } from "@core/services/language-preference.service";

@Component({
    selector: "app-root",
    imports: [RouterModule, NgxSpinnerComponent, TranslatePipe],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent {
    private readonly fgIcons = [
        "fg_scope_in",
        "fg_scope_out",
        "fg_evidence",
        "fg_refund_standard",
        "fg_workflow",
        "fg_info",
        "fg_fruit_test",
        "fg_fruit_test_active",
        "fg_faq",
        "fg_faq_active",
        "fg_feedback",
        "fg_feedback_active",
    ];

    // LanguagePreferenceService is injected once at the root so the saved language is applied
    // (sets <html lang>) before any screen renders.
    constructor(
        private matIconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        _language: LanguagePreferenceService,
    ) {
        for (const icon of this.fgIcons) {
            const fileName = icon.replace(/_/g, "-");
            this.matIconRegistry.addSvgIcon(
                icon,
                this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/fresh-guarantee/${fileName}.svg`),
            );
        }
    }
}
